import React from 'react'
import tw from 'tailwind-styled-components'
import {LangType} from 'yougile-lang'
import {SmallHelp} from '@components/common/help/help'

const TwHeaderContainer = tw.div`
  flex
`
const TwHeaderTitle = tw.div`
  text-sm-semibold
  text-primary
`

interface Props {
  title: string
  help: keyof LangType['help']
  className?: string
}

export const Header = (props: Props) => (
  <TwHeaderContainer className={props.className}>
    <TwHeaderTitle className="mr-8">{props.title}</TwHeaderTitle>
    <SmallHelp name={props.help} />
  </TwHeaderContainer>
)
